import { Filter, ReferenceInput, SelectInput, TextInput, List } from 'react-admin';
import React from 'react';

export const TransactionFilter = (props) => (
    <Filter {...props}>

        <TextInput label="Search" source="global_wallet_account.global_users.email._ilike" alwaysOn parse={value => {
            if(value === "" || value === "%%" || value === "%"){
                return "";
            }else {
                const val = value.split("%")
                    .join("");
                return `%${val}%`
            }

        }} />

    </Filter>
);
